import { Link } from "react-router-dom";

const Mark = ({ size = 40, light = false }) => (
  <span
    className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ${
      light ? "bg-cream p-[3px]" : ""
    }`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <img src="/logo.png" alt="" className="h-full w-full object-contain" />
  </span>
);

export const LogoMark = Mark;

export default function Logo({ light = false, size = 36 }) {
  return (
    <Link to="/" data-testid="logo-home-link" className="inline-flex items-center gap-3 group">
      <span className="transition-transform duration-300 group-hover:-rotate-6">
        <Mark size={size} />
      </span>
      <span className="leading-none">
        <span className={`block font-serif text-xl font-semibold tracking-tight ${light ? "text-cream" : "text-ink"}`}>
          Arnold Bookkeeping
        </span>
        <span className={`mt-1 block font-mono text-[9px] uppercase tracking-[0.32em] ${light ? "text-cream/60" : "text-pine/60"}`}>
          LLC · Pennsylvania
        </span>
      </span>
    </Link>
  );
}
